import { render, staticRenderFns } from "./purchaDate.vue?vue&type=template&id=b940926c"
import script from "./purchaDate.vue?vue&type=script&lang=js"
export * from "./purchaDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports